import React, { useEffect } from "react";
import Logo from "assets/icons/logoSubscriptionModal.png";
import CrossIcon from "assets/icons/cross.svg";
import "./ModalExpiredGame.scss";
import { useNavigate, useLocation } from "react-router-dom";
import RectangleIcon from "assets/icons/bidding/mobile/rectangleModal.svg";
import { showMobile } from "helpers/adaptation";

interface Props {
  visible?: boolean;
  onClose?: () => void;
  type?: "bidding" | "studentFolder";
  firstTitle?: string;
}

const ModalExpiredGame = ({ visible, firstTitle, onClose, type }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (visible && onClose) {
      onClose();
    }
  }, [location.pathname, location.search]);
  return (
    <>
      {visible && (
        <div
          className={`modal-cancel-wrapper-expired ${
            type === "bidding" ? "modal-cancel-wrapper-expired-bidding" : ""
          }`}>
          <div className="fon-cancel-modal">
            {showMobile && (
              <div
                onClick={onClose}
                style={{ textAlign: "center" }}
                className="modal-dialog-content-rectangle">
                <img src={RectangleIcon} />
              </div>
            )}
            <div
              className="cross-container-cancel-modal"
              onClick={onClose}
              style={{ cursor: "pointer" }}>
              <img src={CrossIcon} style={{ width: 16, height: 16 }} />
            </div>
            <div className="inner-content-cancel-modal">
              <div style={{ marginBottom: 30 }}>
                <img src={Logo} style={{ width: 289, height: 287 }} />
              </div>
              <span>{firstTitle || "הגעת לאזור המיועד למנויים בלבד."}</span>
              <span className="modal-description" style={{ marginTop: 30 }}>
                לקבלת גישה חופשית לכל תכני האתר לחצו על הכפתור "רכישת מנוי"{" "}
              </span>
              <div className="SubscriptionDetailsTab-action" style={{ marginTop: 30 }}>
                <input
                  className="save-changes-btn"
                  type="submit"
                  name="submit"
                  value="לרכישת מנוי"
                  onClick={() => navigate("/payment")}
                  style={{ border: "2px solid #ff6360", backgroundColor: "#FF6360", width: 230 }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalExpiredGame;
